module.exports = __webpack_public_path__ + "img/pdk.08f6ad95.jpg";